import React, { SyntheticEvent } from "react";
import { MessageAction } from "../../adapters/insights-agent/state/AppState.ts";
import styles from "./ChatMessages.module.css";

export const RelatedQuestions = (props: {
  relatedQuestionActions: MessageAction[];
  questionElement: (action: MessageAction) => React.JSX.Element;
}) => (
  <div className={styles.RelatedQuestions}>
    <p className={styles.RelatedQuestionsLabel}>Related:</p>
    {props.relatedQuestionActions.map(props.questionElement)}
  </div>
);

RelatedQuestions.Question = (props: {
  onClick: (e: SyntheticEvent) => void;
  action: MessageAction;
}) => (
  <a className={styles.Question} onClick={props.onClick}>
    {props.action.label} <ArrowRight />
  </a>
);

export const ArrowRight = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.41509 1.61816L12.0001 5.99979M12.0001 5.99979L8.41509 10.3814M12.0001 5.99979L0.909179 5.99979"
      stroke="#12CACA"
      strokeWidth="1.45569"
      strokeLinecap="round"
    />
  </svg>
);
